import React from "react";

import { formatNumber, useNavigate, useTranslation } from "utils";

import { ALL_FIELDS_ROUTE } from "consts";

import { NO_FIGURE, StatusCard } from "pages/app/home/status-cards/StatusCard";
import { HomeFieldStats, formatHectares } from "pages/app/home/status-cards/homeFieldStats";

type FieldManagementCardProps = {
  stats: HomeFieldStats;
  hasFields: boolean;
  loading: boolean;
  /** the fields or their practices failed to load: the numbers would read as "nothing enrolled" */
  unavailable?: boolean;
};

export const FieldManagementCard = ({ stats, hasFields, loading, unavailable = false }: FieldManagementCardProps) => {
  const { t } = useTranslation("home");
  const navigate = useNavigate();

  // share of the enrolled fields with complete data
  const progress = stats.enrolledCount > 0 ? (stats.completeCount / stats.enrolledCount) * 100 : 0;
  const goToFields = () => navigate(ALL_FIELDS_ROUTE);

  return (
    <StatusCard
      dataTestId="home-field-management-card"
      loading={loading}
      label={t("statusCards.fieldManagement.label")}
      value={unavailable ? NO_FIGURE : `${formatNumber({ number: progress, decimalPlaces: 0 })}%`}
      valueMuted={unavailable}
      unit={unavailable ? t("statusCards.unavailable") : t("statusCards.fieldManagement.unit")}
      progress={unavailable ? undefined : progress}
      caption={
        unavailable
          ? undefined
          : t("statusCards.fieldManagement.caption", {
              count: stats.enrolledCount,
              formattedCount: formatNumber({ number: stats.enrolledCount, decimalPlaces: 0 }),
              hectares: formatHectares(stats.enrolledHectares),
            })
      }
      cta={{ label: t("statusCards.fieldManagement.cta"), variant: hasFields ? "button" : "circle", onClick: goToFields }}
    />
  );
};
